class ScrollUtil {
  static init() {
    window.lockScroll = false;

    const preventDefault = (e) => {
      if (window.lockScroll) {
        const ev = e || window.event;
        ev.preventDefault();
        ev.returnValue = false;
      }
    };

    window.ontouchmove = preventDefault;
    // ios 11.3 bug
    window.ontouchmove = preventDefault;
  }

  static lock() {
    document.body.style.overflowY = 'hidden';
    window.lockScroll = true;
  }

  static unlock() {
    document.body.style.overflowY = '';
    window.lockScroll = false;
  }

  static isLocked() {
    return window.lockScroll;
  }
}

const createDynamicScheme = (action, paramString) => {
  const anchor = document.createElement('a');
  anchor.setAttribute('style', 'display: hidden');
  anchor.setAttribute(
    'href',
    `chatie-app://${action}${paramString ? `?${paramString}` : ''}`
  );
  document.body.appendChild(anchor);
  return anchor;
};

const copyToClipboard = (text) => {
  const textarea = document.createElement('textarea');
  document.body.appendChild(textarea);

  textarea.style.position = 'absolute';
  textarea.style.left = '-9999px';
  textarea.value = text;
  try {
    textarea.select();
  } catch (error) {}

  if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
    textarea.contentEditable = true;
    textarea.readOnly = true;

    const range = document.createRange();
    range.selectNodeContents(textarea);

    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    textarea.setSelectionRange(0, 99999);
  }

  document.execCommand('copy');
  document.body.removeChild(textarea);
};

const throttle = (callback, limit) => {
  let time = Date.now();
  return (...args) => {
    if (time + limit < Date.now()) {
      callback(...args);
      time = Date.now();
    }
  };
};

const debounce = (callback, wait, context = this) => {
  let timeout = null;
  let callbackArgs = null;

  const later = () => callback.apply(context, callbackArgs);

  return (...args) => {
    callbackArgs = args;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

const raf = (fn, isThrottled) => {
  let isRunning;
  let _args;

  const run = () => {
    isRunning = false;
    fn.apply(this, _args);
  };

  return (...args) => {
    _args = args;

    if (isRunning && isThrottled) {
      return;
    }

    isRunning = true;
    requestAnimationFrame(run);
  };
};

const preventDuplicate = (callback) => {
  let pending = false;

  const done = () => {
    pending = false;
  };

  return (...args) => {
    if (!pending) {
      pending = true;
      callback(...args, done);
    }
  };
};

export default {
  ScrollUtil,
  createDynamicScheme,
  copyToClipboard,
  throttle,
  debounce,
  raf,
  preventDuplicate,
};



// WEBPACK FOOTER //
// ./src/app/utils/dom.js